export const UNSCHEDULED_JOBS_KEY = "unscheduled";

export const WeekOverviewFilterTypes = {
  Jobs: "jobs",
  Price: "price",
};
